/**
 * Padding of a row inside a SettingsSectionCard. Shared so non-row content in a
 * card (loading and error states) can line up with the real rows.
 */
export const SETTINGS_SECTION_ROW_PADDING = { px: 2.25, py: 2 };
